import React, {Component} from 'react';
import InvalidAccessOrLogin from '../errorsPage/InvalidAccessOrLogin';
import Errors from '../common/Errors';
import {Redirect} from 'react-router-dom';
import SimpleReactValidator from 'simple-react-validator';
import {Link} from 'react-router-dom';
import RequiredAstrisk from '../common/RequiredAstrisk';
import 'react-datepicker/dist/react-datepicker.css';
import * as Util from '../common/Util';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

class SalesforceConfiguration extends Component{
    constructor(props){
        super(props);
        this.state = {
            salesforceConfig: {
                integrationMode:"disabled",
                callbackUrl:'',
                clientSecret:'',
                clientId:'',
                authorizationUrl:'',
                tokenUrl:'',
                apiVersion:''

            },
            integrationMode:["Enable Outbound Notifications","Disabled"],
            apiVersion:[2.1,2.2,2.3],
            loggedInUser:{},
            redirectToDashBoard: false,
            redirectToErrorPage: false,
            redirectToForbiddenPage: false,
            apiStatus: {
                isError: false,
                message: '',
                messages: ''
            },
            errorMessage: '',
            showDiv: false,
            showLoader: false,
            showUserName: false,
            showAPILoginId: false,
            showSalesforceClientId: false,
            showSalesforceClientSecret:false,
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.fetchLoggedInStaff = this.fetchLoggedInStaff.bind(this);
        this.fetchSalesforceConf = this.fetchSalesforceConf.bind(this);
        this.validator = new SimpleReactValidator ({
            autoForceUpdate: this,
            element: false
        });
    }

    componentDidMount(){
        if(this.props.params && this.props.params.msg) {
            const {apiStatus} = this.state;
            apiStatus.isError = true;
            apiStatus.message = this.props.params.msg;
            this.setState({apiStatus: apiStatus});
        }
        this.fetchLoggedInStaff();
    }
    fetchLoggedInStaff(){
        let _this = this;
        fetch(this.props.api + '/staff/currentUser', {
            method: 'GET',
            mode: 'cors',
            headers: {
                'X-AUTH-TOKEN': this.props.jwtToken
            }
        })
            .then(response => response.json())
            .then(json => {
                if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                    _this.props.onLogoutClick(json.message);
                }else{
                    if(json && json.staff && json.staff.userRoles.some(v => (v === "ROLE_ADMIN" || v === "ROLE_SYSTEM_SUPPORT" || v === "ROLE_MANAGER"))){
                        _this.setState({loggedInUser: json.staff}, function(){
                            _this.fetchSalesforceConf();
                            const {salesforceConfig} = _this.state;
                        })
                    }else{
                        this.setState({redirectToErrorPage:true})
                    }
                }
                _this.setState({showLoader:false});
            }).catch(error => {
            console.log(error)
        });
    }


    handleChange(event){
        const {salesforceConfig} = this.state;
        const target = event.target;
        const name = target.name;
        const value = target.value;
        salesforceConfig[name]=value;
        this.setState({salesforceConfig:salesforceConfig});
    }

    handleSubmit(event) {
        event.preventDefault();
        const {apiStatus} = this.state;
        this.setState({showLoader: true});
        fetch(this.props.api + "/salesforceConfiguration", {
            method: 'POST',
            mode: 'cors',
            body: JSON.stringify(this.state.salesforceConfig),
            headers: {
                'X-AUTH-TOKEN': this.props.jwtToken,
                'content-type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(json => {
                console.log(json)
                if (json && json.isError === false) {
                    Util.successResponse(apiStatus, json)
                    this.setState({
                        disabledButton: false,
                        apiStatus: apiStatus,
                        showLoader: false,
                        redirectToDashBoard: (apiStatus.isError === false ? true : false)
                    });
                } else {
                    Util.errorResponse(apiStatus, json);
                    if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                        this.props.onLogoutClick(json.message);
                    } else if (json.httpCode === 403 && json.isError === true && json.message === "Forbidden") {
                        this.setState({redirectToForbiddenPage: true});
                    }
                    this.setState({
                        disabledButton: false,
                        apiStatus: apiStatus,
                        showLoader: false
                    });
                }
            })
            .catch(error => {
                Util.errorCatchResponse(apiStatus, error);
                this.setState({disabledButton: false, apiStatus: apiStatus, showLoader: false});
            });
    }
    fetchSalesforceConf() {
        this.setState({showLoader: true});
        fetch(this.props.api +'/salesforceConfiguration', {
            method: 'GET',
            mode: 'cors',
            headers: {
                "X-AUTH-TOKEN": this.props.jwtToken,
                'content-type': 'application/json'
            }
        }).then(response => response.json())
    .then(json => {
            if (json && json.isError === false) {
            const salesforceConfig = json.salesforceConfiguration;
            console.log(salesforceConfig)
            this.setState({salesforceConfig: salesforceConfig, showLoader: false});
        } else {
            this.setState({showLoader: false});
            if (json && json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                this.props.onLogoutClick(json.message);
            } else if (json.httpCode === 403 && json.isError === true && json.message === "Forbidden") {
                this.setState({redirectToForbiddenPage: true});
            }
        }
    }).catch(error => {
            console.log(error);
        this.setState({showLoader: false});

    });

    }

    toggleClientIdVisibility = () => {
        this.setState((prevState) => ({
            showSalesforceClientId: !prevState.showSalesforceClientId,
        }));
    };
    toggleClientSecretVisibility = () => {
        this.setState((prevState) => ({
            showSalesforceClientSecret: !prevState.showSalesforceClientSecret,
        }));
    };



    render() {
        let _this = this;
        const { apiVersion } = this.state;
        const { integrationMode } = this.state
        const { showSalesforceClientId } = this.state;
        const { showSalesforceClientSecret } = this.state;
        return (
            <div className="wrapper animated fadeInRight">
                <InvalidAccessOrLogin jwtToken={this.props.jwtToken}
                                      redirectToErrorPage={this.state.redirectToErrorPage}
                                      redirectToForbiddenPage={this.state.redirectToForbiddenPage}/>
                {
                    (this.state.redirectToDashBoard && this.state.apiStatus && this.state.apiStatus.message) ? (<Redirect to = {'/msg/'+this.state.apiStatus.message}/>):null
                }
                <div className="row">
                    <div className="col-lg-12">
                        <div className="dashboard-table-wrap">
                            <div className="heading-wrapper clearfix">
                                <p className="m-t-xs">{_this.props.msg('salesforceConfiguration.label.header')}</p>
                            </div>
                            <div className="table-box table-responsive p-m" style={{minHeight:'490px'}}>
                                <Errors errorObject={this.state.apiStatus}/>
                                {this.state.showLoader === true ? (<div className="loading">Loading&#8230;</div>) : ''}
                                <form onSubmit={this.handleSubmit} className="form-horizontal">
                                    <div className="col-md-12">
                                        <div className="col-md-10">
                                            <div className="form-group row">
                                                <label
                                                    className="col-lg-5 control-label">{_this.props.msg('salesforceConfiguration.label.intMode')}<RequiredAstrisk/></label>
                                                <div className="col-lg-5">
                                                    <select style={{backgroundPosition: '98% 50%',}}
                                                            key={this.state.salesforceConfig.integrationMode}
                                                            className="form-control"
                                                            id="salesforceIntMode"
                                                            title={this.props.msg('salesforceConfiguration.tooltip.salesforceIntMode')}
                                                            onChange={this.handleChange}
                                                            value={this.state.salesforceConfig.integrationMode ? this.state.salesforceConfig.integrationMode  : ''}
                                                            name="integrationMode"
                                                    >
                                                        {integrationMode.map((integrationMode) => (
                                                            <option key={integrationMode} value={integrationMode.toLowerCase().split(' ').map((word, index) => index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)).join('')}>
                                                                {integrationMode}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label
                                                    className="col-lg-5 control-label">{_this.props.msg('salesforceConfiguration.label.callbackUrl')}<RequiredAstrisk/></label>
                                                <div className="col-lg-5">
                                                    <input type="text" className="form-control" value={this.state.salesforceConfig.callbackUrl ? this.state.salesforceConfig.callbackUrl  : ''} id="salesforceCallbackUrl" title={_this.props.msg('salesforceConfiguration.tooltip.salesforceCallbackUrl')}
                                                           onChange={this.handleChange}
                                                           name="callbackUrl" autoComplete="new-username"

                                                    /></div>
                                            </div>
                                            <div className="form-group row">
                                                <label
                                                    className="col-lg-5 control-label">{_this.props.msg('salesforceConfiguration.label.clientSecret')}<RequiredAstrisk/></label>
                                                <div className="col-lg-5">
                                                    <input type={showSalesforceClientSecret ? "text" : "password"} className="form-control" value={this.state.salesforceConfig.clientSecret ? this.state.salesforceConfig.clientSecret  : ''} id="salesforceClientSecret" title={_this.props.msg('salesforceConfiguration.tooltip.salesforceClientSecret')}
                                                           onChange={this.handleChange}
                                                           name="clientSecret" autoComplete="new-username"

                                                    />
                                                </div>
                                                <div className="col-lg-1">
                                                    <button type="button" onClick={this.toggleClientSecretVisibility} style={{ border: 'none', background: 'none', padding: 0}}>
                                                        {this.state.showSalesforceClientSecret ? <FaEyeSlash /> : <FaEye />}
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label
                                                    className="col-lg-5 control-label">{_this.props.msg('salesforceConfiguration.label.clientId')}<RequiredAstrisk/></label>
                                                <div className="col-lg-5">
                                                    <input type={showSalesforceClientId ? "text" : "password"} className="form-control" value={this.state.salesforceConfig.clientId ? this.state.salesforceConfig.clientId  : ''} id="salesforceClientId" title={_this.props.msg('salesforceConfiguration.tooltip.salesforceClientId')}
                                                           onChange={this.handleChange}
                                                           name="clientId" autoComplete="new-username"

                                                    />
                                                </div>
                                                <div className="col-lg-1">
                                                    <button type="button" onClick={this.toggleClientIdVisibility} style={{ border: 'none', background: 'none', padding: 0 }}>
                                                        {this.state.showSalesforceClientId ? <FaEyeSlash /> : <FaEye />}
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label
                                                    className="col-lg-5 control-label">{_this.props.msg('salesforceConfiguration.label.authUrl')}<RequiredAstrisk/></label>
                                                <div className="col-lg-5">
                                                    <input type="text" className="form-control" value={this.state.salesforceConfig.authorizationUrl ? this.state.salesforceConfig.authorizationUrl  : ''} id="salesforceAuthUrl" title={_this.props.msg('salesforceConfiguration.tooltip.salesforceAuthUrl')}
                                                           onChange={this.handleChange}
                                                           name="authorizationUrl" autoComplete="new-username"

                                                    /></div>
                                            </div>
                                    <div className="form-group row">
                                    <label
                                    className="col-lg-5 control-label">{_this.props.msg('salesforceConfiguration.label.tokenUrl')}<RequiredAstrisk/></label>
                                <div className="col-lg-5">
                                    <input type="text" className="form-control" value={this.state.salesforceConfig.tokenUrl ? this.state.salesforceConfig.tokenUrl  : ''} id="salesforceTokenUrl" title={_this.props.msg('salesforceConfiguration.tooltip.salesforceTokenUrl')}
                                    onChange={this.handleChange}
                                    name="tokenUrl" autoComplete="new-username"

                                    /></div>
                                    </div>
                                            <div className="form-group row">
                                                <label
                                                    className="col-lg-5 control-label">{_this.props.msg('salesforceConfiguration.label.apiVersion')}<RequiredAstrisk/></label>
                                                <div className="col-lg-5">
                                    <select style={{backgroundPosition: '98% 50%',}}
                                    key={this.state.salesforceConfig.apiVersion}
                                    className="form-control"
                                    id="salesforceApiVersion"
                                    title={this.props.msg('salesforceConfiguration.tooltip.salesforceApiVersion')}
                                    onChange={this.handleChange}
                                    value={this.state.salesforceConfig.apiVersion ? this.state.salesforceConfig.apiVersion  : ''}
                                    name="apiVersion"
                                        >
                                        <option value="" disabled>Select API Version</option>
                                    {apiVersion.map((version) => (
                                    <option key={version} value={version}>
                                        {version}
                                        </option>
                                    ))}
                                </select></div>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="col-lg-offset-4 col-lg-7">
                                                <Link to="/" className="btn btn-white" style = {{marginLeft: '7px'}}>{_this.props.msg('form.label.cancelButton')}</Link>&nbsp;&nbsp;&nbsp;
                                                <input className="btn btn-primary" type="submit" value={_this.props.msg('form.label.submit')} disabled={this.state.disabledButton===true}/>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default SalesforceConfiguration


// WEBPACK FOOTER //
// ./src/components/organization/SalesforceConfiguration.js